import { render, staticRenderFns } from "./OtherParticipant.vue?vue&type=template&id=0ff0b9b8"
import script from "./OtherParticipant.vue?vue&type=script&lang=js"
export * from "./OtherParticipant.vue?vue&type=script&lang=js"
import style0 from "./OtherParticipant.vue?vue&type=style&index=0&id=0ff0b9b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports